/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { NotificationsService } from './services/notifications.service';

interface notification {
  messages: any;
  systemMessages: any;
  system: boolean;
}

@Component({
  selector: 'xbaht-navbar-notification',
  templateUrl: './navbar-notification.component.html',
  styleUrl: './navbar-notification.component.scss',
  standalone: false
})
export class NavbarNotificationComponent implements OnInit {
  public notifications?: notification;

  constructor(private _notificationsService: NotificationsService) {}

  ngOnInit(): void {
    this._notificationsService.onApiDataChange.subscribe((res) => {
      this.notifications = res;
    });
  }
}
